import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

export const StyledButton = withStyles({
    root: {
        marginLeft: 20,
        marginRight: 20,
        '&:active': {
            boxShadow: 'none',
        },
    },
    containedPrimary: {
        color: 'white',
    },
})(props => <Button color="default" {...props} />);

export const StyledLoginButton = withStyles({
    root: {
        marginTop: 10,
    },
    containedPrimary: {
        color: 'white',
    },
})(props => <Button color="default" {...props} />);

export const StyledTextField = withStyles({
    root: {
        width: '75%',
        marginTop: 20,
    },
})(props => <TextField {...props} />);

export const StyledLoginTextField = withStyles({
    root: {
        margin: 20,
    },
})(props => <TextField {...props} />);


